<div class="top_panel">
  <div>
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="term.term"
      (input)="onTermChange($event)" />
  </div>
  <button [ngClass]="{'btn_dublicate_on': hideDublicate, 'btn_dublicate': !hideDublicate}"
    (click)="switchDublicateHiding()" title="{{'Hide shared objects'|translate}}"></button>
</div>
<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0,2,3]" *ngIf="objects != undefined && objects.length > 0">
      <tr>
        <th>
          <switch-all-checkbox [items]="GetObjects() | filterByNameAndList: term" />
        </th>
        <th>{{'Name'|translate }}</th>
        <!-- <th *ngIf="currentCompany">{{'Company'|translate }}</th> -->
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let object of GetObjects() | filterByNameAndList: term">
        <td>
          <input *ngIf="showCheckBox(object)" type="checkbox" [(ngModel)]="object.IsChecked"
            (change)="onToggle(object)" />
        </td>
        <td>{{object.Name}}</td>
        <td>
          <button class="btn_img btn_trush " *ngIf="object.CompanyId != currentCompany.Id"
            (click)="deleteEntity(object.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
    <p *ngIf="objects != undefined && objects.length == 0">{{'User does not have any entities attached'|translate}}</p>
  </div>
</div>